<app-print-asset-vehicle-detail></app-print-asset-vehicle-detail>
